module.exports = __webpack_public_path__ + "img/icon-credit-card@3x.86fca1a9.png";